import { ActionCreator } from 'redux';

import {
    ShowMediaManagerAction,
    HideMediaManagerAction,
    ShowMediaManagerUploaderAction,
    HideMediaManagerUploaderAction,
    ShowFileUploadAction,
    ShowFileUploadProgressAction,
    ShowFileSUploadSuccessAction,
    ShowFileUploadErrorAction,
    FileType,
    MediaManagerState,
} from './types';
import { ApplicationState } from '..';

export const ShowMediaManager: ActionCreator<ShowMediaManagerAction> = (): ShowMediaManagerAction => ({
    type: '@@mediaManager/SHOW_MEDIA_MANAGER',
    payload: {
        isOpened: true,
    },
});

export const HideMediaManager: ActionCreator<HideMediaManagerAction> = () => ({
    type: '@@mediaManager/HIDE_MEDIA_MANAGER',
    payload: {
        isOpened: false,
    },
});

export const ShowMediaManagerUploader: ActionCreator<
    ShowMediaManagerUploaderAction
> = (): ShowMediaManagerUploaderAction => ({
    type: '@@mediaManager/SHOW_MEDIA_MANAGER_UPLOADER',
    payload: {
        isUploaderOpened: true,
    },
});

export const HideMediaManagerUploader: ActionCreator<HideMediaManagerUploaderAction> = () => ({
    type: '@@mediaManager/HIDE_MEDIA_MANAGER_UPLOADER',
    payload: {
        isUploaderOpened: false,
    },
});

export const ShowFileUpload: ActionCreator<ShowFileUploadAction> = (file: FileType): ShowFileUploadAction => ({
    type: '@@mediaManager/SHOW_FILE_UPLOAD',
    payload: {
        file,
    },
});

export const ShowFileUploadProgress: ActionCreator<ShowFileUploadProgressAction> = (
    id: string
): ShowFileUploadProgressAction => ({
    type: '@@mediaManager/SHOW_FILE_UPLOAD_PROGRESS',
    payload: {
        id,
        statuses: {
            uploading: true,
        },
    },
});

export const ShowFileUploadSuccess: ActionCreator<ShowFileSUploadSuccessAction> = (
    id: string
): ShowFileSUploadSuccessAction => ({
    type: '@@mediaManager/SHOW_FILE_UPLOAD_SUCCESS',
    payload: {
        id,
        statuses: {
            uploading: false,
            uploaded: true,
        },
    },
});

export const ShowFileUploadError: ActionCreator<ShowFileUploadErrorAction> = (
    id: string
): ShowFileUploadErrorAction => ({
    type: '@@mediaManager/SHOW_FILE_UPLOAD_ERROR',
    payload: {
        id,
        statuses: {
            uploading: false,
            error: true,
        },
    },
});

export const getMediaManagerStore = (state: ApplicationState): MediaManagerState => state.mediaManager;
